import { INotificationForUi, NotificationStatus } from "@modules/api/notifications";

export const notificationMixin = {
    methods: {
        notificationIsRead(notification: INotificationForUi) {
            return notification.status == NotificationStatus.Read;
        }
    }
}